import * as React from 'react';
import styled from 'styled-components';
import * as Blocks from './blocks';
import { LandingPageProvider } from '@ids/context';
import OverwhelmedForm from '@ids/components/OverwhelmedForm';
import { useOverwhelmedOverlayState } from '@ids/context/OverwhelmedOverlay';
import { sendBrazeCustomEvent, TRACKING_IDS_PAGE_LABELS, useAppShell, useFeatureToggle } from '@ids/appshell';
import usePageViewTracking from '@ids/hooks/usePageViewTracking';
import useFocusableSections from '@ids/hooks/useFocusableSections';

const StyledLandingPageLayout = styled.div`
    position: relative;
`;

const Landing = React.memo(() => {
    const { p100StudioPriceTiers } = useFeatureToggle();
    const { isClubBarBannerShown } = useAppShell();
    const landingPageLayoutRef = React.useRef<HTMLDivElement>(null);

    React.useEffect(() => {
        if (landingPageLayoutRef.current) {
            landingPageLayoutRef.current.style.setProperty(
                '--club-bar-banner-height',
                isClubBarBannerShown ? '45px' : '0px'
            );

            if (window.matchMedia('(min-width: 767px)').matches) {
                landingPageLayoutRef.current.style.setProperty(
                    '--club-bar-banner-height',
                    isClubBarBannerShown ? '57px' : '0px'
                );
            }
        }
    }, [isClubBarBannerShown]);

    return (
        <LandingPageProvider>
            <StyledLandingPageLayout data-testid="ids-landing-page" id="ids-landing-page" ref={landingPageLayoutRef}>
                <Blocks.Hero />
                {p100StudioPriceTiers && <Blocks.PriceTiers />}
                <Blocks.WhatYouGet />
                <Blocks.HowItWorks />
                <Blocks.ProjectSlider />
                <Blocks.OurProjects />
                <Blocks.OfflineStudio />
                <Blocks.Reviews />
                <Blocks.FAQ />
                <Blocks.Press />
            </StyledLandingPageLayout>
        </LandingPageProvider>
    );
});
Landing.displayName = 'Landing';

const LandingPage = () => {
    usePageViewTracking(TRACKING_IDS_PAGE_LABELS.LANDING);
    useFocusableSections();

    const { isOverwhelmedOverlayOpen } = useOverwhelmedOverlayState();

    React.useEffect(() => {
        sendBrazeCustomEvent({ name: 'WestwingStudioView' });
    }, []);

    return (
        <React.Fragment>
            <Landing />
            {isOverwhelmedOverlayOpen && <OverwhelmedForm />}
        </React.Fragment>
    );
};

export default LandingPage;
